import { useEffect, useState } from "react";
import { SearchboxViewType } from "../../types/searchbox";
import { subscribeToResize } from "../resizeObserver";

/**
 * React hook to determine whether to render suggestions in columns or in one list
 * based on document width and searchbox view type.
 *
 * @param view - Determines how breakpoints are applied, either "flyout" or "grid".
 * @param isMobileShop - Flag for mobile shop-specific layout behavior.
 * @returns `true` when columns should be shown, `false` for one list.
 */
export default function useSuggestionsRenderView(
    view: SearchboxViewType,
    isMobileShop: boolean
): boolean {
    const [showColumns, setShowColumns] = useState(true);

    useEffect(() => {
        const unsubscribe = subscribeToResize((width) => {
            if (view === "flyout") {
                setShowColumns(getFlyoutRenderView(width, isMobileShop));
            } else if (view === "grid") {
                setShowColumns(getGridRenderView(width));
            }
        });

        return unsubscribe;
    }, [view, isMobileShop]);

    return showColumns;
}

function getFlyoutRenderView(width: number, isMobileShop: boolean): boolean {
    const maxWidthForListView = 767;
    const maxWidthForColumnsView = 991;

    if (isMobileShop || (width > 0 && width <= maxWidthForListView)) {
        return false;
    }
    if (width > maxWidthForListView && width <= maxWidthForColumnsView) {
        return true;
    }
    return true;
}

function getGridRenderView(width: number): boolean {
    const maxWidthForListView = 680;
    return width > maxWidthForListView;
}
